export interface ReasonListProps {
  /** 后端 MatchResult.reasons 原文，前端不改写、不翻译 */
  reasons: string[];
  /** explainScore(result) 生成的分数拆解文案 */
  explain?: string;
  title?: string;
}

/** 可解释理由列表：理由全部来自后端 MatchResult.reasons。 */
export function ReasonList({ reasons, explain, title = '为什么推荐这个人' }: ReasonListProps) {
  return (
    <div className="stack-sm">
      <div className="card-sub">{title}</div>
      {reasons.length === 0 ? (
        <p className="muted small">后端本次没有返回理由（通常是项目还没填技能需求，或候选人数据不足）。</p>
      ) : (
        <ul className="reason-list">
          {reasons.map((reason, index) => (
            <li className="reason-item" key={`${index}-${reason.slice(0, 16)}`}>
              <span className="reason-dot" aria-hidden="true">
                ▸
              </span>
              <span>{reason}</span>
            </li>
          ))}
        </ul>
      )}
      {explain !== undefined ? <div className="explain">{explain}</div> : null}
    </div>
  );
}